<template>
    <div class="color rounded" :class="field"></div>
</template>

<script>
export default {
    props:{
        field:[Object,String,Array,Number]
    }
}
</script>

<style>
    .color{
        width: 50px;
        height: 20px;
        border: 1px solid rgb(224, 224, 224);
    }
</style>